import React from "react";
import {Button, Grid, Typography} from "@mui/material";
import {CallbackHandler, lxStyled, makeLxTranslations} from "@lxo-blocks/react";
import {useLxTranslations} from "@lxo-blocks/react";

const PREFIX = 'MfaDeviceLost';
const classes = {
    link: `${PREFIX}-link`
}
const MfaDeviceLostContainer = lxStyled(Grid)(({theme}) => ({
    [`.${classes.link}`]: {
        color: `${theme.palette.text.secondary}`,
        textTransform: 'none'
    }
}));

export interface MfaDeviceLostButtonProps {
    onResetMfa: CallbackHandler,
    sx: any;
}

const MFA_DEVICE_LOST_BUTTON_TRANSLATION = makeLxTranslations({
    namespace: "mfaDeviceLostButtonTranslations",
    translations: {
        DEVICE_LOST: "Ich habe keinen Zugriff auf die Authentifizierungs-App",
    }
})

export default function MfaDeviceLostButton(props: MfaDeviceLostButtonProps) {
    const {t} = useLxTranslations(MFA_DEVICE_LOST_BUTTON_TRANSLATION);
    return <MfaDeviceLostContainer container
                                   sx={props.sx}
                                   justifyContent="center">
        <Grid item>
            <Button onClick={() => props.onResetMfa()}>
                <Typography className={`${classes.link}`} component="div" variant="body2">
                    {t("DEVICE_LOST")}
                </Typography>
            </Button>
        </Grid>
    </MfaDeviceLostContainer>
}
